import { ColumnName, TableName } from '@models/column';

export interface Join {
  target_table: TableName;
  source_table: TableName;
  join_conditions: JoinCondition[];
}

export type JoinCondition = Geo | PeriodicTime | Same | Time;

export namespace JoinCondition {
  export enum Type {
    Geo = 'Geo',
    PeriodicTime = 'PeriodicTime',
    Same = 'Same',
    Time = 'Time',
  }
}

export interface Geo {
  type: JoinCondition.Type.Geo;
}

export interface PeriodicTime {
  type: JoinCondition.Type.PeriodicTime;
  target_side_column: ColumnName;
  source_side_column: ColumnName;
  periodic_unit: string;
  num_cycles: number;
}

export interface Same {
  type: JoinCondition.Type.Same;
  target_side_column: ColumnName;
  source_side_column: ColumnName;
}

export interface Time {
  type: JoinCondition.Type.Time;
  target_side_column: ColumnName;
  source_side_column: ColumnName;
  from_value: string;
  to_value?: string;
}
